import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Space, Divider, Table, Statistic, Collapse } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { dateFormat } from '../../utils';
import DeckCountBar from '../../components/DeckCountBar';
import _ from 'lodash';
import { motion } from 'motion/react';

function generateStageStats(player) {
  const stats = { stagesplayed: 0, decksplayed: [], totalPoints: 0};
  const decks = [];
  if (player && player.gameHistory) {
    stats.stagesplayed = player.gameHistory.length;
    player.gameHistory.forEach((st) => {
      const deck = {}
      if (decks.findIndex(d => d.name === st.deckName) < 0 ) {
        deck.name = st.deckName;
        deck.count = 1;
        decks.push(deck);
      } else {
        const od = decks.findIndex(d => d.name === st.deckName)
        decks[od].count = decks[od].count + 1;
      }
      stats.totalPoints += st.stagePoints;
    });
    stats.decksplayed = _.orderBy(decks, ['count'], ['desc']);

    // console.warn('stats ricostruite:', stats);
    return stats;
  }
  // stats.stagesplayed = (player && player.gameHistory ? player.gameHistory.length : 0);

  return stats;

}

function generateTournamentStats(player) {
  const stats = { tournamentsplayed: 0, decksplayed: []};
  const decks = [];
  if (player && player.tournamentHistory) {
    stats.tournamentsplayed = player.tournamentHistory.length;
    player.tournamentHistory.forEach((t) => {
      const deck = {}
      if (decks.findIndex(d => d.name === t.deckName) < 0 ) {
        deck.name = t.deckName;
        deck.count = 1;
        decks.push(deck);
      } else {
        const od = decks.findIndex(d => d.name === t.deckName)
        decks[od].count = decks[od].count + 1;
      }
    });
    stats.decksplayed = _.orderBy(decks, ['count'], ['desc']);

    console.warn('stats ricostruite:', stats);
    return stats;
  }
  // stats.stagesplayed = (player && player.gameHistory ? player.gameHistory.length : 0);

  return stats;

}

function Player(props) {
  console.warn('props di player: ',props);
  // let navigate = useNavigate();
  const stageCols = [
    {
      title: 'Stage',
      dataIndex: 'gameHistory',
      key: 'name', 
      render: (state, record) => record.stageInfo.name
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (state, record) => dateFormat(record.stageInfo.date)
    },
    {
      title: 'Season',
      dataIndex: 'gameHistory',
      key: 'seasonInfo',
      render: (state, record) => record.stageInfo.seasonInfo.name
    },
    {
      title: 'Points',
      dataIndex: 'stagePoints',
      key: 'stagePoints',
    },
    {
      title: 'Rank',
      dataIndex: 'stageRank',
      key: 'stageRank',
    },
    {
      title: '',
      dataIndex: 'id',
      render: (state, record) => (<Space><Link to={'/stages/'+record.stageInfo.id+'/'}>
                  <EyeOutlined />
              </Link>
              </Space>),
    }
  ];

  const tournamentCols = [
    {
      title: 'Tournament',
      dataIndex: 'tournamentHistory',
      key: 'name', 
      render: (state, record) => record.tournament.name
    },
    {
      title: 'Type',
      dataIndex: 'tournamentHistory',
      key: 'name', 
      render: (state, record) => record.tournament.type.desc
    },
    {
      title: 'Date',
      dataIndex: 'tournamentHistory',
      key: 'date',
      sorter: (a, b) => { 
        if (a.tournament.date === b.tournament.date) {
          return 0;
        }
        
        if (a.tournament.date < b.tournament.date) {
          return 1;
        } else {
          return -1;
        }
      },
      render: (state, record) => dateFormat(record.tournament.date)
    },
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'Points Earned',
      dataIndex: 'lpiPointsEarned',
      key: 'lpipoints',
      sorter: (a, b) => { 
        // console.warn(a,b);
        if (a.lpiPointsEarned === b.lpiPointsEarned) {
          return 0;
        }
        
        if (a.lpiPointsEarned < b.lpiPointsEarned) {
          return 1;
        } else {
          return -1;
        }
      },
    },
    {
      title: '',
      dataIndex: 'id',
      render: (state, record) => (<Space><Link to={'/tournaments/'+record.tournament.id+'/'}>
                  <EyeOutlined />
              </Link>
              </Space>),
    }
  ];
  
  const player = (props.player.data && props.player.data.payLoad !== null ? props.player.data.payLoad : {})
  const stats = generateStageStats(player); 
  const lpistats = generateTournamentStats(player);

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
    <Card loading={props.player.pending} title={`${player.firstName} ${player.lastName}`} style={{ marginTop: '20px' }}>
      <Row gutter={16}>
        <Col span={6}>
            <Statistic title="Mtgo Nickname" value={player.nickname} />
        </Col>
        <Col span={6}>
            <Statistic title="Date of Birth" value={dateFormat(player.birthDate)} />
        </Col>
        <Col span={6}>
            <Statistic title="LPI Points" value={player.lpiPoints} />
        </Col>
        <Col span={6}>
            <Statistic title="Current TPP Points" value={player.currentTppPoints} />
        </Col>
      </Row>
      <Divider>Player History</Divider>
      <Collapse defaultActiveKey={['Tournaments']}>
        <Collapse.Panel header="Tournament Events" key="Tournaments">
          <Row gutter={[16, 24]} style={{ marginBottom: '20px' }}>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
              <Card title="Top8/16 appearances" style={{ 'width': '100%' }}>
                <Table
                  rowClassName={(record, index) => record.isOlder ? 'table-row-older' :  '' } 
                  columns={tournamentCols} 
                  dataSource={player.tournamentHistory || []}  
                  loading={props.player && !props.player.fulfilled && props.player.pending}
                />
              </Card>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
              <Card title="Used Decks" style={{ 'width': '100%' }}>
                <DeckCountBar metagame={lpistats.decksplayed} height={{ height: '600px' }} />
              </Card>
            </Col>
          </Row>
        </Collapse.Panel>
        <Collapse.Panel header="League Events" key="Leagues">
          <Row gutter={16} style={{ marginBottom: '20px' }}>
            <Col span={8}>
                <Statistic title="Stages played" value={stats.stagesplayed} />
            </Col>
            <Col span={8}>
                <Statistic title="No. of decks used" value={stats.decksplayed.length} />
            </Col>
            <Col span={8}>
                <Statistic title="Average Points per Stage" value={stats.totalPoints/stats.stagesplayed} />
            </Col>
          </Row>
          <Row gutter={[16, 24]} style={{ marginBottom: '20px' }}>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
              <Card title="Stages" style={{ 'width': '100%' }}>
                <Table
                  columns={stageCols} 
                  dataSource={player.gameHistory || []}  
                  loading={props.player && !props.player.fulfilled && props.player.pending}
                />
              </Card>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
              <Card title="Used Decks" style={{ 'width': '100%' }}>
                <DeckCountBar metagame={stats.decksplayed} height={{ height: '600px' }} />
              </Card>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </Card>
    </motion.div>
  );
}

export default Player;